<template>
  <div style="padding: 15px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-col :span="24">
        <el-form-item label="实际承运人实收现金">
          <el-input v-model="row.deliveryCashFee" :disabled="true" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="已打款金额">
          <el-input v-model="row.allotAmount" :disabled="true" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="已分配油点">
          <el-input v-model="row.allotOil" :disabled="true" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="可分配现金" prop="cash">
          <el-input v-model="form.cash" :disabled="true" />
        </el-form-item>
      </el-col>
      <el-col :span="20">
        <el-form-item label="获取验证码" prop="mybankBalancePayDTO.smsCode">
          <el-input
            v-model="form.mybankBalancePayDTO.smsCode"
            max-length="20"
            placeholder="请输入验证码"
          />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-light">
          <el-button
            v-show="show"
            type="primary"
            round
            size="small"
            @click="getCode"
            >获取验证码</el-button
          >
          <span
            v-show="!show"
            style="height: 40px;line-height: 40px;display: block;padding-left: 5px;"
            >{{ count }}</span
          >
        </div>
      </el-col>
      <el-col :span="24">
        <el-button
          type="primary"
          :disabled="updating"
          @click="funcSubmit('form')"
          >确定</el-button
        >
      </el-col>
    </el-form>

    <el-col :span="24">
      <vxe-table border height="250" :data="tableData">
        <vxe-table-column field="orderDetailNumber" title="运单号" />
        <vxe-table-column field="amount" title="分配现金" />
        <vxe-table-column field="gmtCreated" title="分配时间" />
      </vxe-table>
      <vxe-pager
        :loading="loading"
        :page-sizes="Pagingconf"
        :current-page.sync="formPage.pageNum"
        :page-size.sync="formPage.pageSize"
        :total="formPage.total"
        :layouts="[
          'PrevJump',
          'PrevPage',
          'Number',
          'NextPage',
          'NextJump',
          'Sizes',
          'FullJump',
          'Total'
        ]"
        @page-change="handlePageChange"
      />
    </el-col>
  </div>
</template>

<script>
import { remitDefinite, CashPayment } from "@/api/transport";
import { mybankBalancePay } from "@/api/InternetBanking";
import request from "@/utils/request";
export default {
  name: "CashMoney",
  data() {
    return {
      show: true,
      count: "",
      loading: false,
      updating: true,
      tableData: [],
      row: {},
      form: {
        payType: 4,
        cash: "",
        amount: "",
        totalAmount: "",
        orderDetailCode: "",
        balancePayType: 0,
        mybankBalancePayDTO: {
          smsCode: ""
        }
      },
      formPage: {
        payTypes: "3,4,5",
        orderDetailCode: "",
        pageNum: 1,
        pageSize: 20,
        totaltotal: 0
      },
      Pagingconf: [],
      rules: {
        cash: [
          { required: true, message: "请输入可分配现金!", trigger: "blur" }
          // { min: 0, max: 10, message: '长度不超过10个字符', trigger: 'blur' },
        ],
        mybankBalancePayDTO: {
          smsCode: [
            { required: true, message: "请输入验证码", trigger: "blur" },
            { max: 20, message: "长度不超过20个字符" }
          ]
        }
      }
    };
  },
  methods: {
    getInfo(row) {
      this.row = row;
      this.form.orderDetailCode = row.code;
      this.form.amount = "";
      this.form.totalAmount = "";
      this.form.cash = (
        (row.deliveryCashFee * 100 -
          row.allotAmount * 100 -
          row.allotOil * 100) /
        100
      ).toFixed(2);
      this.form.mybankBalancePayDTO.smsCode = "";
      this.Allocationrecord();
    },
    close() {
      this.count = 0;
      this.updating = true;
    },
    //获取验证码
    getCode() {
      this.form.amount = this.form.cash;
      this.form.totalAmount = this.form.cash;
      const $this = this;
      if (this.form.totalAmount == "") {
        this.$message({
          message: "请输可分配现金!",
          type: "warning"
        });
      } else {
        this.verifyPayee(this.form, function() {
          const rLoading = $this.openLoading();
          mybankBalancePay($this.form).then(response => {
            rLoading.close();
            $this.$message({
              message: response.msg,
              type: "success"
            });
            $this.updating = false;
            $this.form.mybankBalancePayDTO = response.data;
            if (response.status == 0) {
              const TIME_COUNT = 60;
              if (!$this.timer) {
                $this.count = TIME_COUNT;
                $this.show = false;
                $this.timer = setInterval(() => {
                  if ($this.count > 0 && $this.count <= TIME_COUNT) {
                    $this.count--;
                  } else {
                    $this.show = true;
                    clearInterval($this.timer);
                    $this.timer = null;
                  }
                }, 1000);
              }
            }
          });
        });
      }
    },
    // 提交
    funcSubmit(form) {
      this.form.amount = this.form.cash;
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          CashPayment(this.form).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.$emit("hideModel");
            rLoading.close();
            this.updating = true;
            this.count = 0;
          });
        } else {
          return false;
        }
      });
    },
    verifyPayee(params, backFun) {
      request({
        url: `/ntocc-tms-api/payAdvance/verifyPayee`,
        method: "get",
        params: params
      }).then(response => {
        if (response.data) {
          backFun();
        } else {
          this.$confirm("本次打款将使本账户汇款超额，是否继续打款操作？").then(
            _ => {
              backFun();
            }
          );
        }
      });
    },
    // 记录列表
    Allocationrecord() {
      this.tableData = [];
      this.loading = true;
      this.formPage.orderDetailCode = this.form.orderDetailCode;
      remitDefinite(this.formPage).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.formPage.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.formPage.pageNum = currentPage;
      this.formPage.pageSize = pageSize;
      this.Allocationrecord();
    },
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    }
  }
};
</script>
